<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-input
          style="width: 300px; margin-right: 10px"
          prefix-icon="el-icon-search"
          v-model="pageQuery.condition.projectName"
          size="small"
          @keydown.enter.native="search"
          @clear="search"
          placeholder="请输入项目名称进行搜索..."
          clearable
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
          size="small"
          >搜索</el-button
        >

        <!-- 保证金日期区间筛选（与"立项汇总"页保持一致） -->
        <el-date-picker
          v-model="rqScope"
          style="margin-left: 10px"
          size="small"
          type="daterange"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
          @change="onDateChange"
        >
        </el-date-picker>

        <!-- 保证金名称筛选已移到「保证金名称」列表头（见下方表格列定义） -->
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button type="success" @click="downloadExcel" size="small">
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出数据</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddView"
          size="small"
          v-if="qx"
          >添加保证金</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div style="margin-top: 20px">
      <!-- :key 绑定筛选值：Element 的表头插槽在父组件数据变化时不会重新求值，
           导致表头里的 el-select 拿不到新值、选中后不回显。改变 key 强制整表重建即可。
           代价：每次改筛选会重建表格（滚动位置/展开状态重置）。 -->
      <el-table
        :data="tableData"
        :key="'marginTable-' + pageQuery.condition.marginCode"
        stripe
        border
        :row-style="{ height: '58px' }"
        height="calc(100vh - 278px)"
        :cell-style="{ padding: '5px 0' }"
        size="small"
        fit
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- 本表已去掉全部固定列（fixed）。
             原因：Element 会把「整行表头」克隆进固定层再裁切，导致表头里的筛选控件在 DOM 里
             出现 3 份、选中值不回显。业务确认横向滚动时不需要钉住这几列，故全部去掉。 -->
        <el-table-column
          prop="projectNo"
          label="项目编码"
          align="center"
          width="130"
        >
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          prop="rq"
          label="保证金日期"
          sortable
          align="center"
          width="120"
        >
        </el-table-column>
        <!-- 保证金名称：筛选移到表头（参照商机管理）。列不写 label，列名由 placeholder 承担 -->
        <el-table-column
          prop="marginName"
          align="center"
          width="150"
        >
          <template slot="header">
            <el-select
              v-model="pageQuery.condition.marginCode"
              size="mini"
              placeholder="保证金名称"
              style="width: 100%"
              filterable
              clearable
              @change="search"
            >
              <el-option
                v-for="item in marginList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="保证金金额" sortable align="center" width="130" :sort-method="(a, b) => a.money - b.money">
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.money) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bz" label="备注" align="center">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="录入人员"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="checkUserName"
          label="复核人员"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
           {{ scope.row.isCheck === '1' ? scope.row.checkUserName : '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          sortable
          label="创建日期"
          align="center"
          width="120"
          :formatter="dateTimeTwoLine"
          class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          sortable
          label="修改日期"
          align="center"
          width="120"
          :formatter="dateTimeTwoLine"
          class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="285"
          v-if="qx"
        >
          <template slot-scope="scope">

            <template v-if="userId != scope.row.userId">
              <el-button type="primary" size="mini" v-if="scope.row.isCheck === '0'" @click="reCheck(scope.row.id, 1)">
                复核
              </el-button>
              <el-button type="warning" size="mini" v-else @click="reCheck(scope.row.id, 0)">
                撤销复核
              </el-button>
            </template>
            <!-- <el-button type="primary" size="mini" style="padding: 2px">编辑</el-button> -->
            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              :disabled="kaiguan(scope.row.createTime) || scope.row.isCheck === '1'"
              >编辑</el-button
            >
            <el-button
              type="danger"
              @click="deleteRecord(scope.row)"
              size="mini"
              :disabled="kaiguan(scope.row.createTime) || scope.row.isCheck === '1'"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 5px;
        "
      >
        <div>保证金金额合计（当前页）: {{ moneyNumber(marginTotal) }}</div>
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="pageQuery.total"
          :current-page="pageQuery.page"
          :page-size="pageQuery.limit"
          :page-sizes="[10, 20, 50, 100, 200]"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框  dialogVisible:是否弹出 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="70%"       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputForm" :model="inputObj" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称" prop="projectId">
                <!--  filterable -->
                <el-select
                  v-model="inputObj.projectId"
                  placeholder="请选择"
                  size="mini"
                  :disabled="xmShow"
                  filterable
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="保证金日期" prop="rq">
                <el-date-picker
                  size="mini"
                  v-model="inputObj.rq"
                  style="width: 250px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="保证金名称" prop="marginCode">
                <el-select
                  v-model="inputObj.marginCode"
                  placeholder="请选择"
                  size="mini"
                  style="width: 250px"
                >
                  <el-option
                    v-for="item in marginList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="保证金金额" prop="money">
                <el-input
                  type="number"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 250px"
                  v-model="inputObj.money"
                  placeholder="请输入金额,单位(元)"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="备注信息" required>
                <el-input
                  type="text"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 770px"
                  v-model="inputObj.bz"
                  placeholder="请输入备注信息"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import { kz } from "../../utils/MyFunction";
import { postRequest } from "@/utils/api";

export default {
  name: "ProjRate",
  data() {
    return {
      qx: true,
      title: "",
      xmShow: false,
      tableData: [], // 存放查询结果
      loading: false,
      marginTotal: 0, // 保证金金额合计（仅统计当前页返回的数据）
      rqScope: [], // 保证金日期区间（绑定日期控件，提交时拆成 rqBegin/rqEnd）
      pageQuery: {
        page: 1,
        limit: 50,
        total: 0,
        condition: {
          projectName: "",
          rqBegin: "", // 保证金日期起
          rqEnd: "", // 保证金日期止
          marginCode: "", // 保证金名称（按代码精确筛选）
        },
      },
      dialogVisible: false,
      // 新增保证金对象
      inputObj: {
        id: null,
        projectId: null,
        rq: "",
        marginCode: "",
        money: null,
        bz: "",
      },
      projects: [], //项目id-项目名称下拉框
      marginList: [], // 保证金 下拉框
      rules: {
        projectId: [
          {
            required: true,
            message: "请选择项目名称",
            trigger: "blur",
          },
        ],
        rq: [
          {
            required: true,
            message: "请选择保证金日期",
            trigger: "blur",
          },
        ],
        marginCode: [
          {
            required: true,
            message: "请选择保证金代码",
            trigger: "blur",
          },
        ],
        money: [
          {
            required: true,
            message: "请输入保证金金额",
            trigger: "blur",
          },
        ],
      },
      userId: sessionStorage.getItem('uid')
    };
  },
  mounted() {
    this.quanxian();
    this.initRate();
    this.initDim();
  },
  methods: {
    // 复核操作
    reCheck(id, isCheck){
      let tipText = (isCheck === 1 ? '是否复核此条录入信息?': '是否撤销复核?')
      this.$confirm(tipText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postRequest2('/project/margin_check',{ id, isCheck}).then(res => {
          if(res.code === 200){
            this.initRate();
          }
        })
      })
    },
    moneyNumber(val) {
      // 与"借款管理"统计保持一致：全角￥ + 数字（无千分位，最多 2 位小数）
      return "￥" + Number(Number(val || 0).toFixed(2));
    },
    // ==================== 导出 Excel（exceljs，数据驱动，不读 DOM） ====================
    // 文件名用的日期后缀：YYYYMMDD
    exportFileDate() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}`;
    },
    // 列表查询与导出共用同一套筛选参数，避免两处拼参不一致
    buildMarginQuery(page, limit) {
      return {
        page: page,
        limit: limit,
        condition: Object.assign({}, this.pageQuery.condition),
      };
    },
    // 导出列定义：页面表格列去掉"操作"列与创建日期/修改日期（业务确认导出不需要时间列）
    // 注意：页面表格仍保留创建/修改日期列，仅导出不含；不要顺手加回来。
    getExportColumns() {
      return [
        { header: "项目编码", key: "projectNo", width: 18 },
        { header: "项目名称", key: "projectName", width: 36, align: "left" },
        { header: "保证金日期", key: "rq", width: 14 },
        { header: "保证金名称", key: "marginName", width: 16 },
        { header: "保证金金额", key: "money", width: 15, money: true },
        { header: "备注", key: "bz", width: 24, align: "left" },
        { header: "录入人员", key: "userName", width: 12 },
        { header: "复核人员", key: "checkUserName", width: 12 },
      ];
    },
    // 用数据数组生成 Excel（exceljs 体积较大，动态导入，仅在点击导出时加载）
    // rows      - 要导出的数据数组
    // fileName  - 文件名，如 "项目保证金录入_20260212.xlsx"
    // sheetName - 工作表名，默认取文件名去掉扩展名
    async exportRowsToExcel(rows, fileName, sheetName) {
      const mod = await import(/* webpackChunkName: "exceljs" */ "exceljs");
      // 兼容 CJS 模块被 webpack 包装成 { default: ... } 的情况
      const ExcelJS =
        mod && mod.Workbook ? mod : mod && mod.default ? mod.default : mod;
      const columns = this.getExportColumns();

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet(
        sheetName || String(fileName || "Sheet1").replace(/\.xlsx$/i, "")
      );

      // 列定义（表头行由 columns.header 自动生成）
      sheet.columns = columns.map((col, i) => ({
        header: col.header,
        key: "c" + i,
        width: col.width,
      }));

      const thin = { style: "thin", color: { argb: "FFD0D0D0" } };

      // 表头样式：加粗 + 灰底 + 居中 + 边框
      const headerRow = sheet.getRow(1);
      headerRow.height = 22;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, size: 11, color: { argb: "FF515A6E" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFEEF1F6" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { top: thin, left: thin, bottom: thin, right: thin };
      });

      // 冻结首行：滚动时表头常驻
      sheet.views = [{ state: "frozen", ySplit: 1 }];

      // 数据行
      (rows || []).forEach((row) => {
        const values = columns.map((col) => {
          const raw = col.format ? col.format(row) : row[col.key];
          // 空值写成真正的空单元格，不写 "--"，避免影响 Excel 求和
          if (raw === null || raw === undefined || raw === "") return null;
          if (col.money) {
            const n = Number(raw);
            return isNaN(n) ? null : n;
          }
          return raw;
        });
        const added = sheet.addRow(values);

        columns.forEach((col, i) => {
          const cell = added.getCell(i + 1);
          cell.border = {
            top: { style: "thin", color: { argb: "FFE8E8E8" } },
            left: { style: "thin", color: { argb: "FFE8E8E8" } },
            bottom: { style: "thin", color: { argb: "FFE8E8E8" } },
            right: { style: "thin", color: { argb: "FFE8E8E8" } },
          };
          if (col.money) {
            // 千分位 + 两位小数；保留数值类型，可在 Excel 中继续排序/求和
            cell.numFmt = "#,##0.00";
            cell.alignment = { horizontal: "right", vertical: "middle" };
          } else {
            cell.alignment = {
              horizontal: col.align || "center",
              vertical: "middle",
            };
          }
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        fileName
      );
    },
    // 导出入口：按当前筛选条件拉全量数据后直接生成 Excel（不渲染表格，无需还原分页状态）
    downloadExcel() {
      const EXPORT_LIMIT = 99999; // 用超大 limit 让服务端返回"筛选后的全部记录"
      const fileName = "项目保证金录入_" + this.exportFileDate() + ".xlsx";
      this.loading = true;
      this.postRequest(
        "/project/margin-list",
        this.buildMarginQuery(1, EXPORT_LIMIT)
      )
        .then((res) => {
          this.loading = false;
          const rows = (res && res.data && res.data.records) || [];
          if (!rows.length) {
            this.$message({
              type: "warning",
              message: "当前筛选条件下没有数据",
            });
            return;
          }
          return this.exportRowsToExcel(rows, fileName).catch((e) => {
            console.log(e);
            this.$message({ type: "error", message: "导出失败，请重试" });
          });
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
        });
    },
    quanxian() {
      if (!window.sessionStorage.getItem("userRoleId")) {
        //权限为空
        // 暂时不做处理，本来应该直接退出
      } else {
        if (window.sessionStorage.getItem("userRoleId") == 8) {
          this.qx = false;
        }
        if (window.sessionStorage.getItem("userRoleId") == 17) {
          this.qx = false;
        }
        // 销售(角色id 2)只读：隐藏"添加"按钮与整个操作列
        if (this.doesItContain([2]).length > 0) {
          this.qx = false;
        }
      }
    },
    kaiguan(sj) {
      var sf = kz(sj);
      return sf;
    },
    doChance() {
      this.dialogVisible = false;
      this.initRate();
    },
    showEditView(data) {
      this.title = "编辑保证金";
      this.dialogVisible = true;
      this.xmShow = true;
      this.inputObj = data;
    },
    deleteRecord(data) {
      this.$confirm(
        "此操作将永久删除 " + data.projectName + "的该条保证金明细, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.getRequests("/project/margin-remove", { id: data.id }).then(
            (resp) => {
              if (resp) {
                this.initRate();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    doAddRecord() {
      this.$refs["inputForm"].validate((valid) => {
        if (valid) {
          //验证通过
          this.postRequest("/project/margin-save", this.inputObj).then(
            (resp) => {
              if (resp) {
                this.dialogVisible = false;
                this.initRate();
              }
            }
          );
        }
      });
    },
    initDim() {
      if (!window.sessionStorage.getItem("projects")) {
        this.getRequest("/dim/project").then((resp) => {
          if (resp) {
            this.projects = resp.result;
            this.saveDictCache("projects", resp.result);
          }
        });
      } else {
        this.projects = this.dictCache("projects");
      }
      if (!window.sessionStorage.getItem("margins")) {
        this.postRequest("/dim/dim_table_char/margin_code").then((resp) => {
          if (resp) {
            this.marginList = resp.result;
            this.saveDictCache("margins", resp.result);
          }
        });
      } else {
        this.marginList = this.dictCache("margins");
      }
    },
    currentChange(currentPage) {
      this.pageQuery.page = currentPage;
      this.initRate();
    },
    sizeChange(limit) {
      this.pageQuery.limit = limit;
      this.pageQuery.page = 1;
      this.initRate();
    },
    // 条件查询：回到第 1 页再查，避免停留在超出结果范围的页码上
    search() {
      this.pageQuery.page = 1;
      this.initRate();
    },
    // 保证金日期区间变化：拆成起止日期后查询
    onDateChange(val) {
      if (val && val.length === 2) {
        this.pageQuery.condition.rqBegin = val[0];
        this.pageQuery.condition.rqEnd = val[1];
      } else {
        this.pageQuery.condition.rqBegin = "";
        this.pageQuery.condition.rqEnd = "";
      }
      this.search();
    },
    showAddView() {
      this.title = "添加保证金";
      this.dialogVisible = true;
      this.xmShow = false;
      this.inputObj = {
        id: null,
        projectId: null,
        rq: "",
        rateCode: "",
        rate: null,
      };
    },
    initRate() {
      this.loading = true;
      this.postRequest(
        "/project/margin-list",
        this.buildMarginQuery(this.pageQuery.page, this.pageQuery.limit)
      ).then((res) => {
        this.loading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.pageQuery.total = res.data.total;
          // 合计（当前页）：只累加本次返回的数据，翻页/改每页条数/筛选后重新计算
          this.marginTotal = 0;
          (res.data.records || []).forEach((item) => {
            this.marginTotal = Number(
              (this.marginTotal + Number(item.money || 0)).toFixed(2)
            );
          });
        }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    sessionStorage.removeItem("projects");
    next();
  },
};
</script>

<style>
</style>
